"use client"

import { useEffect } from "react"

import { trackEvent } from "@/lib/analytics"

const AI_REFERRERS = [
  ["chatgpt", "chatgpt"],
  ["openai", "chatgpt"],
  ["perplexity", "perplexity"],
  ["gemini", "gemini"],
  ["bard.google", "gemini"],
  ["claude", "claude"],
  ["copilot", "copilot"],
] as const

export function AiReferralTracker() {
  useEffect(() => {
    if (!document.referrer) return
    let hostname = ""
    try {
      hostname = new URL(document.referrer).hostname.toLowerCase()
    } catch {
      return
    }
    const match = AI_REFERRERS.find(([needle]) => hostname.includes(needle))
    if (!match) return

    const key = `yo-ai-referral:${match[1]}:${window.location.pathname}`
    try {
      if (window.sessionStorage.getItem(key)) return
      window.sessionStorage.setItem(key, "1")
    } catch {
      // sessionStorageが使えなくても匿名イベントの送信は続ける
    }
    trackEvent("ai_referral", {
      ai_source: match[1],
      landing_path: window.location.pathname,
    })
  }, [])

  return null
}
